//A page's custom CSS may tag a section, row, column, text or image with a role by putting "--ve": "<role>" in
//its styles (the BSM 2026 agenda generator does: tasks/agenda-page/agenda-bsm2026/scripts/build_variant_e_pages.py).
//The role is also written as a data-ve attribute, so the CSS can select [data-ve="time"] exactly instead of
//searching the text of every style attribute ([style*="--ve: time;"]). Measured on a phone-speed CPU (09/30/2026):
//those substring selectors made every restyle of the agenda about 4x slower. No role, no attribute.
export const styleRole = (styles) =>
  styles && styles['--ve'] ? { 'data-ve': styles['--ve'] } : {};

//What a column or row holds, for the same custom CSS: data-pb-holds = the element types inside ("Image Button"),
//data-ve-holds = their roles ("title pill-coach"). Lets the CSS say .ant-col[data-pb-holds~="Image"] instead of
//.ant-col:has(img), which the browser re-checks on every change inside the page. Empty lists write no attribute.
export const holds = (elements) => {
  const list = elements || [];
  const types = [...new Set(list.map((e) => e && e.type).filter(Boolean))];
  const roles = [
    ...new Set(
      list.map((e) => e && e.styles && e.styles['--ve']).filter(Boolean)
    )
  ];
  return {
    'data-pb-holds': types.length ? types.join(' ') : undefined,
    'data-ve-holds': roles.length ? roles.join(' ') : undefined
  };
};
